import { render, staticRenderFns } from "./SidePanelNews.vue?vue&type=template&id=117c7e7b&scoped=true&"
import script from "./SidePanelNews.vue?vue&type=script&lang=js&"
export * from "./SidePanelNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117c7e7b",
  null
  
)

export default component.exports